// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__29Wqu","wrapper_description":"wrapper_description__1ncSz"};